// Data
import actionsServiceCaller from '../lib/app/actions-service-caller';

// Configs
import servicesFormConfig from '../../config/services-form-config';

// Redux Actions
import {globalResponseAdd} from './global-response-actions';

export function generateMarker({guid, markerType, forceRegenerate, forceIncludeFirstEpisode}) {
    return (dispatch) => {
        const dispatchFetched = (jsonResponse) => {
            dispatch({
                type: 'GENERATE_MARKER_FULFILLED',
                response: jsonResponse || `Marker generation request queued for ${markerType}.`,
                markerType,
            });
            dispatch(globalResponseAdd({
                success: `Marker generation request for ${markerType} has been successfully queued for record ${guid}.`,
            }));
        };
        const dispatchError = (error) => {
            dispatch({
                type: 'GENERATE_MARKER_REJECTED',
                error,
                markerType,
            });
            dispatch(globalResponseAdd({
                error: `Marker generation failed for ${markerType}: ${error}`,
            }));
        };

        const queryParams = {guid, markerType};

        if (forceRegenerate) {
            queryParams.forceRegenerate = true;
        }
        if (markerType === 'FINGERPRINT' && forceIncludeFirstEpisode) {
            queryParams.forceIncludeFirstEpisode = true;
        }

        const actionParams = {
            servicesConfig: servicesFormConfig.generateMarker,
            dispatchFetched,
            dispatchError,
        };

        dispatch({
            type: 'GENERATE_MARKER',
            markerType,
        });

        return actionsServiceCaller(actionParams, queryParams);
    };
}

export function generateMarkerReset() {
    return (dispatch) => {
        dispatch({
            type: 'GENERATE_MARKER_RESET',
        });
    };
}
